// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Bi9O","actions":"GroupTable_actions__1NZk4","deleteModalFooter":"GroupTable_deleteModalFooter__2Rumb"};